import { Injectable } from '@angular/core'
import { PlayHistoryApi } from './base'

@Injectable()
export class VideoPlayHistoryApi extends PlayHistoryApi{
  apiPath(resourceId: number, areaId = '') {
    return `videos/${resourceId}/play_histories/${areaId}`
  }
}



// WEBPACK FOOTER //
// ./src/apis/play-history/video.ts